import { render, staticRenderFns } from "./saleBill.vue?vue&type=template&id=40e16921&scoped=true&"
import script from "./saleBill.vue?vue&type=script&lang=js&"
export * from "./saleBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e16921",
  null
  
)

export default component.exports